var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{ref:"network",staticClass:"network",attrs:{"nodes":_vm.nodes,"edges":_vm.edges,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }